import React from "react";
import Nav from "react-bootstrap/Nav";
import { NavpillContainer } from "../styles";
import { INavPillProps } from "../interfaces";

const NavPills: React.FC<INavPillProps> = ({
  defaultActiveKey,
  pills,
  onSelect,
  bgColor,
  activeKey,
  className,
}) => {
  return (
    <NavpillContainer bgColor={bgColor} className={className}>
      <Nav
        fill
        variant="tabs"
        defaultActiveKey={defaultActiveKey}
        activeKey={activeKey}
      >
        {pills?.map((pill) => (
          <Nav.Item
            key={pill.key}
            onClick={() => {
              if (!pill?.isDisabled && onSelect) {
                onSelect(pill.key);
              }
            }}
          >
            <Nav.Link
              eventKey={pill.key}
              disabled={pill?.isDisabled ? pill.isDisabled : false}
            >
              {pill.title}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </NavpillContainer>
  );
};

export default NavPills;
